import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaginationControlsComponent } from '../common-components/pagination-controls/pagination-controls.component';
// import { ColDef, GridApi, GridOptions, GridReadyEvent, themeBalham } from 'ag-grid-community';
// import { CustomColumnHeaderModule } from '../common-components/column-header/column-header.module';
import { AiSearchService } from './ai-search.service';
import { customSort } from '../utils/ag-grid-utils';
import { SearchData } from './models/search-data';
import { ItemSearchResponseModel } from './models/item-search-response-model';
// import { SupplierCellRendererComponent } from './supplier-cell-renderer.component';
import { Pagination } from '../models/paging/paging';

@Component({
  selector: 'ai-search',
  standalone: true,
  imports: [FormsModule, PaginationControlsComponent],
  templateUrl: './ai-search.component.html',
})
export class AiSearchComponent implements OnInit {
  public error: boolean = false;
  public errorMessage: string = '';
  public showSpinner: boolean = false;
  public searchQuery: string = '';
  public taxonomySearch: boolean = false;
  public taxonomySearchText: string = '';
  public rowDefs: any[] = [];
  public rowHeight = 32;
  public totalCount: number = 0;
  public pagination: Pagination = new Pagination(this.performSearch.bind(this));
  public filters = {
    itemId: '',
    description: '',
    detailedDescription: '',
    itemState: '',
    itemStateDescription: '',
    alsisProductCode: '',
    alsisScope: '',
    lifecycleManagementStatus: '',
    lifecycleManagementStatusDescription: '',
    originSource: '',
    publishingSource: ''
  };



  constructor(public aiSearchService: AiSearchService) {

  }

  ngOnInit() {
    // Perform initial search on load
    this.performSearch();
  }

  toggleRow(index: number) {
    this.rowDefs[index].expanded = !this.rowDefs[index].expanded;
  }

  buildFiltersArray(): string[] {
    const filterArray: string[] = [];
    if (this.filters.itemId) filterArray.push(`itemId:${this.filters.itemId}`);
    if (this.filters.description) filterArray.push(`description:${this.filters.description}`);
    if (this.filters.detailedDescription) filterArray.push(`detailedDescription:${this.filters.detailedDescription}`);
    if (this.filters.itemState) filterArray.push(`itemState:${this.filters.itemState}`);
    if (this.filters.itemStateDescription) filterArray.push(`itemStateDescription:${this.filters.itemStateDescription}`);
    if (this.filters.alsisProductCode) filterArray.push(`alsisProductCode:${this.filters.alsisProductCode}`);
    if (this.filters.alsisScope) filterArray.push(`alsisScope:${this.filters.alsisScope}`);
    if (this.filters.lifecycleManagementStatus) filterArray.push(`lifecycleManagementStatus:${this.filters.lifecycleManagementStatus}`);
    if (this.filters.lifecycleManagementStatusDescription) filterArray.push(`lifecycleManagementStatusDescription:${this.filters.lifecycleManagementStatusDescription}`);
    if (this.filters.originSource) filterArray.push(`originSource:${this.filters.originSource}`);
    if (this.filters.publishingSource) filterArray.push(`publishingSource:${this.filters.publishingSource}`);
    return filterArray;
  }

  // onGridReady(params: GridReadyEvent<any>) {
  //   // this.gridApi = params.api;
  // }

  onSearch() {
    this.pagination.currentPage = 1;
    this.performSearch();
  }

  performSearch() {
    this.showSpinner = true;
    this.error = false;
    this.errorMessage = '';

    const searchData: SearchData = {
      searchText: this.searchQuery || '',
      filters: this.buildFiltersArray(),
      resultList: [],
      totalCount: 0,
      top: this.pagination.pageSize,
      skip: (this.pagination.currentPage - 1) * this.pagination.pageSize,
      taxonomySearch: this.taxonomySearch,
      taxonomySearchText: this.taxonomySearchText
    };

    this.aiSearchService.searchItemsWithFilters(searchData).subscribe({
      next: (response) => {
        this.showSpinner = false;
        // this.rowDefs = response.resultList.map((item: any, index: number) => ({ ...item, expanded: index === 0 }));
        this.rowDefs = response.resultList.map((item: any, index: number) => ({ ...item }));
        this.totalCount = response.totalCount || 0;
        this.pagination.onDataUpdate(response.totalCount || 0);
        
      },
      error: (error) => {
        this.errorMessage = 'An error occurred while searching';
        this.error = true;
        this.showSpinner = false;
        console.error('Search error:', error);
      }
    });
  }
}

